const OPAReducer = (state = {}, action) => {
  switch (action.type) {
    case "OPA_LISTVIEW":
      return Object.assign({}, state, {
        OPA_ListView: action.data
      });
    case "OPA_ACTIVITY":
      return Object.assign({}, state, {
        OPA_Actvity: action.data
      });
    case "OPA_ADD":
      return Object.assign({}, state, {
        OPA_Add: action.data
      });
    case "OPAEDIT_DOCS":
      return Object.assign({}, state, {
        geteditopa: action.data
      });

    case "SHARE_OPADATAS":
      return Object.assign({}, state, {
        sharedopadata: action.data
      });
    case "ERROR_OPADATAS":
      return Object.assign({}, state, {
        erroropapass: action.data
      });
    default:
      return state;
  }
};

export default OPAReducer;

